// src/locales/en/common.js
export const common = {
    id: "ID",
    save: "Save",
    saving: "Saving",
    saveChanges: "Save Changes",
    cancel: "Cancel",
    info: "Info",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    update: "Update",
    updating: "Updating...",
    creating: "Creating...",
    duplicate: "Duplicate",
    search: "Search",
    loading: "Loading...",
    processing: "Processing...",
    yes: "Yes",
    no: "No",
    ok: "OK",
    back: "Back",
    next: "Next",
    previous: "Previous",
    pageOf: "Page {{page}} of {{total}}",
    continue: "Continue",
    submit: "Submit",
    reset: "Reset",
    clear: "Clear",
    clearSelection: 'Clear Selection',
    close: "Close",
    open: "Open",
    view: "View",
    download: "Download",
    print: "Print",
    printReceipt: "Print Receipt",
    export: "Export",
    upload: "Upload",
    required: "Required",
    optional: "Optional",
    select: "Select",
    selectAll: "Select All",
    deselectAll: "Deselect All",
    applyToAll: "Apply to All",
    actions: "Actions",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    enabled: "Enabled",
    disabled: "Disabled",
    or: "or",
    moreActions: "More actions",
    retry: "Retry",
    refresh: "Refresh",
    clearSearch: "Clear Search",
    clearFilters: "Clear Filters",
    clearAll: "Clear All",
    all: "All",
    filter: "Filter",
    success: "Success",
    goBack: "Go Back",
    created: "Created",
    createdBy: "Created By",
    updatedAt: "Updated",
    selectedCount: "{{count}} selected",
    selected: "selected",
    uploading: "Uploading...",
    secondsAgo: "{{count}} seconds ago",
    minutesAgo: "{{count}} minutes ago",
    hoursAgo: "{{count}} hours ago",
    daysAgo: "{{count}} days ago",
    monthsAgo: "{{count}} months ago",
    yearsAgo: "{{count}} years ago",
    shop: "Shop",
    inStock: 'In stock',
    outOfStock: 'Out of stock',
    accessDenied: "Access Denied",
    na: "N/A",
    country: "Country",
    
    // Pagination
    sortBy: "Sort By",
    showingResults: "Showing {{start}} to {{end}} of {{total}} results",
    page: "Page",
    of: "of",
    perPage: "per page",
    firstPage: "First page",
    lastPage: "Last page",
    nextPage: "Next page",
    previousPage: "Previous page",
    show: "Show",
    hide: "Hide",

  // Actions
  confirm: 'Confirm',
  confirmUpdate: 'Confirm Update',
  
  // States
  readOnly: 'Read Only',
  
  // Messages
  error: 'Error',
  validationError: 'Validation Error',
  notAvailable: 'N/A',

  // Table / report labels
  count: 'Count',
  total: 'Total',

  // Clipboard
  copy: "Copy",
  copiedToClipboard: "Copied to clipboard!",
  copyFailed: "Could not copy to clipboard",

  // Bulk import (shared across bulk order / bulk product import flows)
  bulkDragDropFile: 'Drag and drop your Excel file here',
  bulkOrClickToSelect: 'or click to select file',
  bulkSupportedFormats: 'Supported formats: .xlsx, .xls, .csv',
  bulkFileUploaded: 'File uploaded successfully',
  bulkInvalidFileFormat: 'Invalid file format. Please upload .xlsx, .xls or .csv file',
  bulkFileParsingError: 'Error parsing file. Please check the file format',
    loadingData: "Loading data...",
    viewDetails: "View Details",
    createdDate: "Created Date",
    none: "None",
    excel: "Excel",
    ref: "Ref",
  unsavedChangesTitle: "Unsaved changes",
  leave: "Leave",
  stay: "Stay",
};